// Shopify search splits Chinese/Japanese queries into single characters and ranks fuzzy matches,
// so "秋元通明" returns hundreds of loosely related books. Wrapping each CJK term in quotes turns it
// into an exact phrase match over title and description (where book descriptions carry a hidden
// author/translator/publisher block). Latin terms are left alone to keep typo tolerance.
//
// Queries are folded to simplified characters first (zh-t2s.js, the same table the admin uses for
// the simplified copy in the hidden block), so 臺灣漫遊錄 / 台灣漫遊錄 / 台湾漫游录 all find the book.
// The original text travels as ?oq= so the search box shows what the reader typed.
//
// Exact phrases miss near misses (挪威森林 vs 挪威的森林), so when they find few products the
// results page and the predictive dropdown add unquoted ("broad") results after the exact ones.
// Unquoted CJK matches single characters, so this is skipped for short queries (names like 杨双子),
// where it only adds noise.
(function () {
  const CJK = /[぀-ヿ㐀-鿿豈-﫿]/;
  const PREDICTIVE_MIN = 3;
  const PREDICTIVE_MAX = 8;
  const RELATED_MAX = 24;
  const BROAD_MIN_CJK = 4;
  let t2s = null;

  function searchUrl() {
    return (window.routes && window.routes.search_url) || '/search';
  }

  function toSimplified(text) {
    if (!t2s) {
      t2s = new Map();
      const chars = Array.from(window.motataZhT2sPairs || '');
      for (let i = 0; i + 1 < chars.length; i += 2) t2s.set(chars[i], chars[i + 1]);
    }
    let out = '';
    for (const ch of text) out += t2s.get(ch) || ch;
    return out;
  }

  window.motataQuoteCjk = function (query) {
    if (!query) return query;
    const simplified = toSimplified(query);
    if (simplified.includes('"')) return simplified;
    return simplified
      .trim()
      .split(/\s+/)
      .map((term) => (CJK.test(term) && term.length > 1 ? `"${term}"` : term))
      .join(' ');
  };

  // Unquoted query for the fallback, or '' when there is none worth running.
  window.motataBroadQuery = function (query) {
    const broad = toSimplified(query || '').replace(/"/g, '').trim();
    const cjkCount = Array.from(broad).filter((ch) => CJK.test(ch)).length;
    return cjkCount >= BROAD_MIN_CJK ? broad : '';
  };

  function productPath(href) {
    return href ? new URL(href, window.location.origin).pathname : '';
  }

  function productPaths(root) {
    return new Set(
      Array.from(root.querySelectorAll('a[href*="/products/"]'), (a) => productPath(a.getAttribute('href')))
    );
  }

  // Predictive dropdown: append broad product results to the exact ones (both are parsed
  // #shopify-section-predictive-search elements). With no exact products, show the broad markup.
  window.motataMergePredictive = function (exact, broad) {
    const exactList = exact.querySelector('#predictive-search-results-products-list');
    const broadList = broad.querySelector('#predictive-search-results-products-list');
    if (!broadList) return exact;
    if (!exactList) return broad;
    const seen = productPaths(exactList);
    let count = exactList.children.length;
    for (const li of Array.from(broadList.children)) {
      if (count >= PREDICTIVE_MAX) break;
      const path = productPath(li.querySelector('a[href]')?.getAttribute('href'));
      if (!path || seen.has(path)) continue;
      seen.add(path);
      count++;
      li.id = `predictive-search-option-product-${count}`;
      exactList.appendChild(li);
    }
    return exact;
  };

  window.motataPredictiveNeedsBroad = function (section) {
    return section.querySelectorAll('#predictive-search-results-products-list > li').length < PREDICTIVE_MIN;
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = new URL(form.action, window.location.origin).pathname;
      if (action !== searchUrl()) return;
      const input = form.querySelector('input[name="q"]');
      if (!input || input.type === 'hidden') return;
      const original = input.value.trim();
      input.value = window.motataQuoteCjk(input.value);
      let oq = form.querySelector('input[name="oq"]');
      if (input.value !== original) {
        if (!oq) {
          oq = document.createElement('input');
          oq.type = 'hidden';
          oq.name = 'oq';
          form.appendChild(oq);
        }
        oq.value = original;
      } else if (oq) {
        oq.remove();
      }
    },
    true
  );

  // Results page: show the reader's own text, and fill the related block with broad results.
  function initSearchPage() {
    const params = new URLSearchParams(window.location.search);
    const oq = params.get('oq');
    const input = document.getElementById('Search-In-Template');
    if (oq && input) input.value = oq;

    const box = document.querySelector('[data-motata-related]');
    if (!box) return;
    const q = params.get('q') || '';
    const broad = window.motataBroadQuery(q);
    if (!broad) return;
    const url = `${searchUrl()}?q=${encodeURIComponent(broad)}&type=product&section_id=${box.dataset.sectionId}`;
    fetch(url)
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        const list = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('#product-grid ul.product-grid');
        if (!list) return;
        const seen = productPaths(document.getElementById('ProductGridContainer') || document.createElement('div'));
        const grid = list.cloneNode(false);
        for (const li of Array.from(list.children)) {
          if (grid.children.length >= RELATED_MAX) break;
          const path = productPath(li.querySelector('a[href*="/products/"]')?.getAttribute('href'));
          if (!path || seen.has(path)) continue;
          seen.add(path);
          // Reveal-on-scroll only hooks up cards present at page load.
          for (const el of [li, ...li.querySelectorAll('.scroll-trigger')]) {
            el.classList.remove('scroll-trigger', 'animate--slide-in');
          }
          grid.appendChild(li);
        }
        if (!grid.children.length) return;
        box.querySelector('[data-motata-related-grid]').appendChild(grid);
        box.hidden = false;
      })
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }
})();
